module.exports = __webpack_public_path__ + "media/src/images/icons/print/red-906998d83036be92ce138fbd0beacd28.svg";